const trackingTranslation = {
  mode: 'ko',
  menu: '정산',

  babymagicsMenu: '베이비매직 정산',
  barcodesMenu: '바코드 정산',
  plansMenu: '요율 관리',

  babymagicOrders: '주문 내역',
  babymagicRefunds: '환불 내역',
  barcodeOrders: '바코드 주문',
  barcodeRefunds: '바코드 환불',
  settlements: '월별 정산',
  planDefinition: '플랜 정의',
  hospitalContracts: '병원별 계약 확인',

  // refunds
  refundOrder: '환불 처리',
  babyMagicRefundProcessing: '베이비매직 환불 처리',
  barcodeRefundProcessing: '바코드 환불 처리',
  pleaseEnterRefundReason: '환불 사유를 입력해주세요',
  enterRefundReason: '환불 사유를 입력하세요',
  processRefund: '환불 처리',

  // For table
  index: '번호',
  orderNumber: '주문 번호',
  refundNumber: '환불 번호',
  barcodeNumber: '바코드 번호',
  hospitalName: '병원명',
  planName: '플랜명',
  planType: '서비스 유형',
  billingMethod: '과금 방식',
  unitPrice: '단가',
  monthlyPrice: '월 고정 금액',
  description: '설명',
  orderStatus: '주문 상태',
  createdAt: '생성 일시',
  refundedAt: '환불 일시',
  refundReason: '환불 사유',
  refundedReason: '환불 사유',
  appliedPlan: '적용 플랜',
  appliedPlanTooltip: '적용된 플랜 정보를 확인할 수 있습니다',

  // Order status
  complete: '주문 완료',
  refunded: '환불 완료',

  // Refund reasons
  customerComplaint: '고객 컴플레인',
  serviceError: '서비스 오류',
  other: '기타',
  refundReasonPlaceholder: '환불 사유를 입력하세요',

  // Plan tooltip
  type: '유형',
  babyMagic: '베이비매직',
  barcode: '바코드',
  price: '{{unit}}{{price}}',
  KRW: '원',
  USD: '달러',
  VND: '동',
  IDR: '루피(인니)',
  MXN: '페소(멕시코)',

  // Billing methods
  perCase: '건별',
  monthlyFixed: '월 정액',
  perCaseAndMonthly: '건별 + 월 정액',

  // Search and filter
  hospitalSearch: '병원 검색',
  yearSelect: '연도 선택',
  yearSelectPlaceholder: '연도를 선택하세요',
  planNamePlaceholder: '플랜명을 입력하세요',
  startDate: '시작일',
  endDate: '종료일',
  csvDownload: 'CSV 다운로드',
  hospitalSearchPlaceholder: '병원명을 입력하세요',
  barcodeNumberPlaceholder: '바코드 검색',
  orderNumberPlaceholder: '주문 번호 검색',
  dateRange: '기간 선택',
  startDatePlaceholder: '시작일',
  endDatePlaceholder: '종료일',
  today: '오늘',
  oneWeek: '1주일',
  oneMonth: '1개월',
  threeMonths: '3개월',

  // Plan registration modal
  addPlan: '신규 플랜 등록',
  pleaseEnterPlanName: '플랜명을 입력해주세요',
  max20Characters: '최대 20자',
  enterPlanName: '플랜명을 입력하세요',
  enterNumbersOnly: '숫자만 입력해 주세요',
  atLeastOneFeeRequired: '건별 요금과 월 고정 요금 중 최소 하나는 필수 입력해야 합니다.',
  enterPlanDescription: '플랜에 대한 설명을 입력하세요',
  cancel: '취소',
  register: '등록',

  // Hospital plan management
  addHospitalPlan: '신규 병원 계약 등록',
  pleaseSelectPlanType: '플랜 유형을 선택해주세요',
  feeByCase: '건별 요금',
  feeMonthly: '월 고정 요금',

  // Hospital plan modal
  newHospitalContractRegistration: '신규 병원 계약 등록',

  // Settlement management
  yearMonth: '연월',
  generatedCount: '생성 건수',
  refundCount: '환불 건수',
  validCount: '유효 건수',
  settlementAmount: '정산 금액',
  adjustmentAmount: '조정 금액',
  adjustmentReason: '조정 사유',
  adjustmentCount: '병원 판매 건수',
  finalSettlementAmount: '최종 정산 금액',
  settlementStatus: '정산 상태',
  confirmed: '정산 확정',
  unconfirmed: '미정산',
  enterAdjustmentReason: '조정 사유를 입력하세요',
  selectHospital: '병원을 선택하세요',
  pleaseSelectHospital: '병원을 선택해주세요',
  selectPlan: '플랜을 선택하세요',
  pleaseSelectPlan: '플랜을 선택해주세요',
  applicationPeriod: '적용 기간',
  pleaseSelectApplicationPeriod: '적용 기간을 선택해주세요',
  endDateOptional: '종료일(선택)',
  contractTerminationInfo: '등록 시 동일 병원 및 서비스 유형의 기존 계약은 자동 종료됩니다.',
  count: '{{count}}건',
  totalCount: '총 {{count}}건',
  viewDetail: '상세 내역 보기',
  confirm: '확정',
  confirmSettlement: '정산을 확정 하시겠습니까?',
  confirmCancelSettlement: '미정산 상태로 되돌리시겠습니까?',
  revert: '되돌리기',
  image: '등록 이미지',
  viewImage: '이미지 보기',

  // End date management
  changeContractEndDate: '계약 종료일을 변경하시겠습니까?',
  setContractEndDate: '계약 종료일을 설정하시겠습니까?',
  change: '변경',
  set: '설정',
  selectEndDate: '종료일 선택',

  // Success messages
  REQUEST_SUCCESS: '요청이 성공적으로 완료되었습니다.',

  // Error messages
  UNKNOWN_ERROR: '알 수 없는 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
  PLAN_NAME_ALREADY_EXISTS: '이미 존재하는 플랜명입니다.',
  PLAN_TYPE_NOT_FOUND_FOR_PLAN_SEQ: '플랜을 찾을 수 없습니다.',
  ORDER_NOT_FOUND_FOR_ORDER_SEQ: '주문을 찾을 수 없습니다.',
};

export default trackingTranslation;
